import { createContext, useContext, useState, useCallback, useEffect } from 'react';
import { PaywallModal } from '../../features/paywall';

const PaywallContext = createContext(null);

export const PaywallProvider = ({ children }) => {
  const [courseCode, setCourseCode] = useState(null);

  const showPaywall = useCallback((code) => {
    if (!code) {
      console.error('[PaywallContext] showPaywall called without courseCode');
      return;
    }
    setCourseCode(code);
  }, []);

  const hidePaywall = useCallback(() => {
    setCourseCode(null);
  }, []);

  // Register global paywall handler
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.__paywallHandler = showPaywall;
      return () => {
        delete window.__paywallHandler;
      };
    }
  }, [showPaywall]);

  const value = {
    showPaywall,
    hidePaywall,
    isOpen: !!courseCode,
    courseCode,
  };

  return (
    <PaywallContext.Provider value={value}>
      {children}
      <PaywallModal
        isOpen={!!courseCode}
        courseCode={courseCode}
        onClose={hidePaywall}
      />
    </PaywallContext.Provider>
  );
};

export const usePaywall = () => {
  const context = useContext(PaywallContext);
  if (!context) {
    throw new Error('usePaywall must be used within PaywallProvider');
  }
  return context;
};
